import type { SiteType } from '@Types/Shared/SiteDatas';

export default function Logo({ site, logo }: { site: SiteType; logo?: string }) {
	return (
		<a href={site.url} className='block'>
			{logo ? (
				<img
					src={logo}
					alt={site.name}
					className='mx-auto max-h-[60px] max-w-[120px] tablet:minos-footer-logo-size-width tablet:minos-footer-logo-size-height tablet:m-0 tablet:max-h-none tablet:max-w-none'
				/>
			) : (
				''
			)}
		</a>
	);
}
